import { render, staticRenderFns } from "./FolderSettings.vue?vue&type=template&id=13ca4866&scoped=true"
import script from "./FolderSettings.vue?vue&type=script&lang=js"
export * from "./FolderSettings.vue?vue&type=script&lang=js"
import style0 from "./FolderSettings.vue?vue&type=style&index=0&id=13ca4866&prod&lang=scss&scoped=true"
import style1 from "./FolderSettings.vue?vue&type=style&index=1&id=13ca4866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca4866",
  null
  
)

export default component.exports